import { differenceInBusinessDays } from 'date-fns';
import { getUserProperty } from '@atlassian/jira-common-rest/src/api/latest/user-properties/index.tsx';

export const checkIfActivatedMoreThanFourDays = (productUsageStartTimestamp: string) => {
	const diffInDays = differenceInBusinessDays(new Date(), new Date(productUsageStartTimestamp));

	return diffInDays >= 4;
};

export const normalizeError = (error: unknown) => {
	if (error instanceof Error) {
		return error;
	}
	return new Error('Unknown error');
};

export interface DeferredPromise<T> {
	promise: Promise<T>;
	resolve: (value: T) => void;
	reject: (reason?: unknown) => void;
}

export function createDeferredPromise<T>(): DeferredPromise<T> {
	// These will be properly initialized in the Promise constructor
	let resolve!: (value: T) => void;
	let reject!: (reason?: unknown) => void;
	const promise = new Promise<T>((res, rej) => {
		resolve = res;
		reject = rej;
	});
	return { promise, resolve, reject };
}

/**
 * For onboarding content we only want to display if some others have been displayed and dismissed.
 * e.g. "Display spotlight X, only after Y and Z have been dismissed"
 */
export const checkPrerequisiteDismissals = async (
	prerequisiteDismissals: string[],
	accountId?: string,
) => {
	if (!accountId) {
		return;
	}

	const prerequisiteDismissalsPromises = prerequisiteDismissals.map((prerequisite) => {
		return getUserProperty<boolean>(accountId, prerequisite);
	});

	return Promise.all(prerequisiteDismissalsPromises);
};
